import React from 'react';
import cssmodules from 'react-css-modules';
import TableFilterHeader from '../Shared/TableFilterHeader';
import {DropdownButton,MenuItem} from 'react-bootstrap';
import { Link } from 'react-router';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';
import Select from 'react-select';

class CipGroupTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      filterEnabled : false,
      filter : {
        Title : '',
        ManagerId : -1
      }
    }
  }

  toggleFilter(event){
    this.setState({
      filterEnabled : !this.state.filterEnabled
    });
  }


  handleFilterChange(propertyName, event){
    var value = typeof event === 'object' ? event.target.value : event;
    
    let filter = Object.assign(this.state.filter, 
          {[propertyName] : value}
    );
    this.setState({
      filter : filter
    });
    const { onFilterChanged } = this.props;    
    onFilterChanged && onFilterChanged(filter);
  }

  handleSelectChange(propId, event){
      

      const value = event ? event.Id : -1;
      let filter = Object.assign(this.state.filter, 
          {[propId] : value}
      );
      this.setState({
        filter : filter
      });
      const { onFilterChanged } = this.props;    
      onFilterChanged && onFilterChanged(filter);
  }

  render() {
    
    const { cipGroupContainer } = this.props;
    const { cipGroupManagers } = this.props;
    const { IsAdmin } = this.props;
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };

    return (
    <div className="brand-panel panel panel-default filterable cipgrouptable-component">
        <div className="panel-heading">
                <h3 className="panel-title">{t('CIP Groups')}
                   {
                     cipGroupContainer.Loading && (<span className="fa fa-refresh fa-spin" style={{marginLeft:'10px'}}></span>)
                   }
                </h3>
                <div className="pull-right">

                    <button className="btn btn-default btn-xs btn-filter" onClick={this.toggleFilter.bind(this)}><span className="glyphicon glyphicon-filter"></span> {t('Filter')}</button>
                  </div>
        </div>
        <div className="panel-body">
         {
          IsAdmin &&   
          <div className="btn-group pull-right" role="group" style={{paddingBottom:'10px'}}>
            <Link type="button" className="btn btn-default btn-brand" to="/cipGroup">
              <span className="glyphicon glyphicon-plus"></span>
              {t('Add')}</Link>
          </div>
        }
          <table className="table table-condensed table-striped table-bordered">
            <thead>
              <tr>
                  <TableFilterHeader filterEnabled={this.state.filterEnabled} label="#" style={{maxWidth : '50px'}}>
                       <input value={this.state.filter.CipGroupId} onChange={this.handleFilterChange.bind(this, 'CipGroupId')} type="text" className="form-control input-sm" placeholder={t('Id')}/>
                  </TableFilterHeader>
                  <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Name')}>
                    <input value={this.state.filter.Title} onChange={this.handleFilterChange.bind(this, 'Title')} type="text" className="form-control input-sm" placeholder={t('Name')}/>
                  </TableFilterHeader>
                  <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Account')}>
                    <p className="form-control-static">{t('Account')}</p>
                  </TableFilterHeader>
                  <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Manager')}>
                    <Select placeholder={t('Select') + ' ...'}
                            value={this.state.filter.ManagerId}
                            options={cipGroupManagers.Managers}
                            onChange={this.handleSelectChange.bind(this,"ManagerId")
                      }
                  />
                  </TableFilterHeader>
                  {false && <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Department')}>
                    <p className="form-control-static">{t('Department')}</p>
                  </TableFilterHeader>
                  }

                   <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Coach name')}>
                    <p className="form-control-static">{t('Coach name')}</p>
                  </TableFilterHeader>
                  <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Active')}>
                    <p className="form-control-static">{t('Active')}</p>
                  </TableFilterHeader>
              </tr>
            </thead>
            <tbody>
              {
                (cipGroupContainer.Groups).map((g, idx) => 
                  (<tr key={g.Id}>
                      <td><Link to={"/cipGroup/" + g.Id}>{g.Id}</Link></td>
                      <td>{g.Title}</td>
                      <td>{g.Account ? g.Account.Amount : 0}</td>
                      <td>{g.CipGroupManager ? g.CipGroupManager.DisplayName : ''}</td>
                      <td>{g.CipGroupCoachName}</td>
                      <td><i className={g.IsActive ? "glyphicon glyphicon-ok" : "glyphicon"}/></td>
                  </tr>)
                )
              }
            </tbody>
          </table>
        
        </div>
    </div>
    );
  }
}

CipGroupTable.displayName = 'CipGroupTable';
CipGroupTable.propTypes = {};
CipGroupTable.defaultProps = {
  cipGroupContainer : {
    Loading : true,
    Groups : []
  }
};

export default injectIntl(CipGroupTable);


// WEBPACK FOOTER //
// ./components/CipGroups/CipGroupTable.js